import PropTypes from 'prop-types';
import React from 'react';
import AssembliesSection from './AssembliesSection.jsx';
import FarmSection from './FarmSection.jsx';
import { userSelector, imperativeEditUser } from 'modules/currentUser';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { isEligibleForPro } from 'models/users';
import { createLeaderProfile } from 'api/users';
import AppChannel from 'modules/channels/App';
import { useDispatch } from 'react-redux';

export const ContextPanel = ({ hostAssemblies, farm, hasPendingLeaderProfile }) => {
    const currentUser = useSelector(userSelector);
    const dispatch = useDispatch();

    const isUserFrench = currentUser?.locale === 'fr_FR';

    const handleCreateLeaderProfile = () => {
        const allowCreation = isEligibleForPro(currentUser);

        if (allowCreation) {
            createLeaderProfile(currentUser.id)
                .then(() => {
                    dispatch(
                        imperativeEditUser(
                            R.mergeRight({
                                leaderProfile: {
                                    blob: '{}',
                                    status: 'init',
                                },
                            })
                        )
                    );
                    AppChannel.commands.execute('navigate', 'progress', true);
                })
                .catch(() => {});
        } else {
            AppChannel.commands.execute('navigate', 'validate/scu/host', true);
        }
    };

    return (
        <div className="contextPanel u-p-0">
            <AssembliesSection
                hostAssemblies={hostAssemblies}
                hasPendingLeaderProfile={hasPendingLeaderProfile}
                canCreateLeaderProfile={!currentUser.leaderProfile}
                createLeaderProfile={handleCreateLeaderProfile}
                isUserFrench={isUserFrench}
                hasFarm={!!farm}
                shouldShowMiniRucheLink
            />
            <FarmSection farm={farm} />
        </div>
    );
};

ContextPanel.propTypes = {
    hostAssemblies: PropTypes.array,
    farm: PropTypes.object,
    hasPendingLeaderProfile: PropTypes.bool,
};

export default ContextPanel;
